import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/scss/custom.scss'
import '@/assets/scss/animate.scss'
import '@/assets/scss/breakpointsForJS.scss'
import 'bootstrap-icons/font/bootstrap-icons.css'
import Vue from 'vue'
import { TablePlugin, PaginationPlugin } from 'bootstrap-vue'
import VCalendar from 'v-calendar'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/dateFormat.js'

Vue.use(TablePlugin)
Vue.use(PaginationPlugin)
Vue.use(VCalendar)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
